require('./dashboard-template.html');

var isIntegerValue = function(d) {
  return Boolean((d + '').match(/^[0-9]+$/));
};

angular.module('bbl.module.dashboard.controller', [])
  .controller('DashboardController', [
    '$scope', '$rootScope', '$routeParams', '$timeout', '$window',
    'PusherUpdates', 'PusherPubsub', 'ConferenceCalls', 'Auth',
    'PlivoService', 'userInfo', 'permissions', 'Toast', 'Api',
    'Calls', 'modals', '$filter', 'CallManager', 'SocketUpdates',

    DashboardController
  ]);

function DashboardController(
  $scope, $rootScope, $routeParams, $timeout, $window, PusherUpdates,
  PusherPubsub, ConferenceCalls, Auth, plivo, userInfo, permissions,
  Toast, Api, Calls, modals, $filter, CallManager, SocketUpdates
) {
  var $format = $filter('cLineFm');

  $scope.mode = {showAll: false};
  $scope.callersFiltersMap = {
    is_muted: 'Muted',
    is_unmuted: 'Unmuted',
    is_deafened: 'Deafened',
    has_hand_raised: 'Has hand raised',
  };

  $scope.userInfo = userInfo;
  $scope.company = (userInfo || {}).company || {};
  $scope.showConferenceAudioPlayer = sessionStorage.getItem('AifConsauyhPeeeldneroocwr') || ($scope.company.id+'' === '6542') || ($scope.company.id+'' === '43');
  $scope.allowScreenshare = $scope.company.allow_screenshare;
  $scope.showJoinZoomMeetingCTA = $scope.company.warn_promo === true;
  $scope.permission_level = permissions;
  $scope.d = {ACTIVE_BRIDGE: null, CONFERENCE: null};

  if ($scope.company.id) {
    SocketUpdates.subscribeTo($scope.company.id);
  }

  if($scope.userInfo && !$scope.userInfo.toast_notifications) {
    Toast.snooze(Infinity);
  }

  subscribe(PusherPubsub, PusherPubsub.types.SMS_RECEIVED, function onSmsReceived(data) {
    Toast.notify('{{\'Sms from\'|translate}} <b>{{caller_name}}</b>:<br><br><p>{{sms_content}}</p>', {
      persistent: true,
      data: data,
    });
  });

  var dview = sessionStorage.getItem('dview');
  if(dview) {
    $scope.d.view = dview;
  }

  $scope.onSelectBridge = function(activeBridge) {
    if (!activeBridge || !activeBridge.in_progress_conferences_caller_count) {
      return;
    }

    if ($scope.d.CONFERENCE && $scope.d.CONFERENCE.bridge_id !== activeBridge.id) {
      $scope.d.CONFERENCE = null;
    }

    var conference = activeBridge.in_progress_conference_calls[0].conference;
    Api.fetchOne('/bridges/api/v1/conference/', conference, {cache: false}).then(function(response) {
      $scope.d.CONFERENCE = response;
    });
  };

  $scope.getViewMode = function() {
    if(!$scope.MODEL) {
      return;
    }

    var viewMode = ($scope.userInfo.prefer_tile_view || '').toLowerCase();
    return $scope.d.view || (
      $scope.d.view = {t: 'tile', w: 'list'}[viewMode] || ($scope.MODEL.length >= 20 ? 'list' : 'tile'));
  };

  $scope.setViewMode = function(mode) {
    // ensure mode === list||view
    $scope.d.view = {tile: 'tile', list: 'list'}[mode] || $scope.d.view;
    sessionStorage.setItem('dview', $scope.d.view);
  };

  $scope.intercomEvent = function(evt) {
    if($window.Intercom) {
      $window.Intercom('trackEvent', evt);
    }
  };

  $scope.intercomMsg = function(msg) {
    if(typeof msg != 'string') {
      msg = angular.element(msg.target).attr('data-msg');
    }

    if($window.Intercom) {
      $window.Intercom('showNewMessage', msg);
    }
  };

  function mapBridges(bridges) {
    bridges.forEach(function(bridge, pos){
      bridge.pos = pos+1;

      var inProgrCalls = bridge.in_progress_conference_calls;

      if(Array.isArray(inProgrCalls)){
        inProgrCalls = inProgrCalls.filter(function(call){
          return !call.toBeRemovedCall && call.status !== 'completed';
        }).map(function(call){
          call.has_hand_raised = !!call.hand_raised_at;
          call.uuid = call.uuid || call.unique_id || call.unique_ss_id;
          return Calls(call, bridge);
        });

        bridge.in_progress_conference_calls = inProgrCalls;
        bridge.in_progress_conferences_caller_count = inProgrCalls.length;
      }

      PusherUpdates.subscribeTo(bridge.id);
    });

    return bridges;
  }

  subscribe(Api.bridges, function(bridges){
    $scope.MODEL = mapBridges(bridges);

    $scope.d.ACTIVE_BRIDGE = $scope.MODEL.reduce(function(active, bridge) {
      return bridge.in_progress_conferences_caller_count > 0 ? bridge : active;
    }, $scope.MODEL[0]);

    $scope.onSelectBridge($scope.d.ACTIVE_BRIDGE);
  });

  if($routeParams.addModal === 'add') {
    Api.bridges.once($timeout.bind(0, $scope.$evalAsync.bind($scope, 'showAddNumberModal()'), 150));
  }

  // fetch bridges
  Api.bridges.fetch({limit: 3}).then(Api.bridges.fetch.bind(Api.bridges, {limit: 100})).then(function(data) {
    // if data is from cache, update cache with new api request
    if(data && data.__fromCache) {
      Api.bridges.fetch({limit: 100}, {cache: false});
    }
  });

  $scope.joinFromBrowser = function(bridge) {
    if(CallManager.getCall()) {
      Toast.error("{{'You\\\'re already in a conference, please disconnect before joining another one!'|translate}}");
      return;
    }

    var call = CallManager.createCall(bridge);
  };

  $scope.openDialogShare = function($event, bridge) {
    var base_url = $window.location.protocol + "//" + $window.location.host + $window.location.pathname;
    var url = base_url + "#join-call/" + bridge.token_link_anon + "?bid="+bridge.id;
    $window.prompt("Copy to clipboard: Ctrl+C, Enter", url);
  };

  $scope.confirmBoot = function confirmBoot() {
    if($window.confirm('Are you sure you want to remove caller\'s name from this call?')) {
      return (new $.Deferred()).resolve().promise();
    }
  };

  var findBridge = function(bridgeId) {
    return $scope.MODEL.filter(function(bridge) { return bridge.id == bridgeId; })[0];
  };

  var findCall = function(bridge, search, field) {
    var brCalls = bridge.in_progress_conference_calls,
      inProgrCalls = Array.isArray(brCalls) ? brCalls : [];

    return inProgrCalls.filter(function(call){
      return call[field||'id'] == search;
    })[0];
  };

  var updateBridgeActiveCalls = function(bridge, addCall, removeCall, callersCount) {
    var activeCalls = bridge.in_progress_conference_calls || [];
    // make sure activeCalls is array
    activeCalls = (Array.isArray(activeCalls) ? activeCalls : []).slice();

    // filter out inactive calls
    activeCalls = activeCalls.filter(function(call){
      return !call.toBeRemovedCall && (call.id !== removeCall);
    });

    var isExistingCall = addCall && activeCalls.filter(function(call) {
      return call.id === addCall.id;
    })[0];

    if(!isExistingCall && addCall) {
      var i = activeCalls.map(function(c) {return c.index;});
      addCall.index = Math.max.apply(Math, [0, activeCalls.length-1].concat(i))+1;
      activeCalls.push(addCall);
    }

    bridge.in_progress_conference_calls = activeCalls;
    var callsCount = activeCalls.length;
    bridge.in_progress_conferences_caller_count = callsCount;

    return activeCalls;
  };

  PusherUpdates.initConnection();


  var onCallerNameChange = function (data) {
    var bridge = findBridge(data.bridgeId);

    var activeCalls = bridge.in_progress_conference_calls || [];
    // make sure activeCalls is array
    activeCalls = (Array.isArray(activeCalls) ? activeCalls : []).slice();
    var _call = activeCalls.filter(function(c) {
      return [data.call_id, data.conferenceCallId].indexOf(c.id) > -1;
    })[0];

    if (_call) {
      _call.name = data.conferenceCallName || _call.name;
    }
  };

  var onCallerJoin = function (data) {
    var bridge = findBridge(data.bridgeId);

    updateBridgeActiveCalls(bridge, Calls(data.conferenceCall, bridge), null, data.callersCount);

    var cname = $format(data.conferenceCall.name);
    if(!(bridge.seminar || Toast.muted())) {
      Toast.notify("{{'A new caller'|translate}}, <strong>"+ cname +"</strong> {{'joined the conference'|translate}}.", {snoozable: true});
    }

    if (Notify.needsPermission) {
      return;
    }

    (new Notify('A new caller!', {
      body: cname + ' joined the conference.',
      timeout: 15,
      tag: data.conferenceCall.name,
      icon:'assets/images/logo_square.png'
    })).show();
  };

  var onCallerLeft = function (data) {
    var bridge = findBridge(data.bridgeId);

    if(!bridge) {
      console.error('Couldn\'t find a bridge with id', data.bridgeId, 'on event caller left.');
      return;
    }

    var activeCalls = updateBridgeActiveCalls(bridge, null, data.conferenceCall.id, data.callersCount);

    // if no callers left on the line, call conference ended
    if(activeCalls.length === 0) {
      onConferenceEnded(null, data);
    }

    if(!(bridge.seminar || Toast.muted())) {
      var cname = $format(data.conferenceCall.name);
      var uid = data.deafenedCallId+'left';
      Toast.notify("{{'Caller'|translate}} <strong>"+ cname +"</strong> {{'left the conference'|translate}}.", {uid: uid, snoozable: true});
    }
  };

  var onCallerMuted = function (data) {
    var bridge = findBridge(data.bridgeId);
    if(!bridge) {
      console.error('Couldn\'t find a bridge with id', data.bridgeId, 'on event caller left.');
      return;
    }

    var call = findCall(bridge, data.mutedCallId);

    // check if there's an active call
    if(!call) {
      return;
    }

    call.is_muted = data.isMuted;
    var uid = data.deafenedCallId+'mute';

    if (data.silent) {
      return;
    }

    Toast.notify("{{'Caller'|translate}} <b>{{call.name|cLineFm}}</b> {{'was'|translate}} <b>{{status|translate}}</b>.", {
      uid: uid, data: {
        call: call,
        status: call.is_muted ? 'muted': 'unmuted'
      }
    });
  };

  var onCallerDeafened = function (data) {
    var bridge = findBridge(data.bridgeId);
    var call = findCall(bridge, data.deafenedCallId);

    call.is_deafened = data.isDeafened;
    var uid = data.deafenedCallId+'deaf';
    Toast.notify("{{'Caller'|translate}} <b>{{call.name|cLineFm}}</b> {{'was'|translate}} <b>{{status|translate}}</b>.", {uid: uid, data: {call: call, status: call.is_deafened ? 'deafened': 'undeafened'}});
  };

  var onCallerNudget = function (data) {
    var bridge = findBridge(data.bridgeId);
    var call = findCall(bridge, data.nudgedCallId);

    call.is_nudged = data.isNudged;
  };

  var onNameRecorded = function (data) {
    var bridge = findBridge(data.bridgeId);
    var call = findCall(bridge, data.conferenceCall.id),
      callData = (data.conferenceCall[0] || data.conferenceCall).fields || data.conferenceCall;

    // check if there's an active call
    if(!call) {
      return;
    }

    call.recorded_name = callData.recorded_name;
  };

  var onHandRaisedUpdate = function(event, data) {
    var bridge = findBridge(data.bridgeId);
    if (!bridge) {
      return;
    }
    var call = findCall(bridge, data.raiseHandCallId);

    var conferencecallData = data.conferenceCall[0].fields || data.conferenceCall[0];
    call.has_hand_raised = data.raisedHandStatus+'' === 'true';
    call.hand_raised_at = conferencecallData.hand_raised_at;
    if (data.raisedHandStatus){
      Toast.notify("{{'Caller'|translate}} <strong>"+ $format(conferencecallData.name) +"</strong> {{'raised their hand'|translate}}.");
    }
    // trigger scope apply
    $timeout(function(){});
  };

  /**
   * Required data for this event:
   * bridgeId
   */
   $scope.$on('pusher:call:hand_raised_at', onHandRaisedUpdate);

  /**
   * Required data for this event:
   * bridgeId
   * hand_raised_at
   * raiseHandCallId
   */
   $scope.$on('pusher:call:caller_raised_hand', onHandRaisedUpdate);

  var onSpeakerChange = function (data) {
    var bridge = findBridge(data.bridgeId),
      ipcc = bridge.in_progress_conference_calls,
      calls = Array.isArray(ipcc) ? ipcc : [];

    var _call = calls.filter(function(call) {
      call.is_speaking = false;

      if(call.id === data.conferenceCallId) {
        call.is_speaking = true;
        call.room = data.conferenceCall.room;
        call.status = data.conferenceCall.status;
      }

      return call.is_speaking;
    })[0] || {};

    if(!(bridge.seminar || Toast.muted())) {
      Toast.notify("{{'Caller'|translate}} <b>{{name|cLineFm}}</b> {{'is speaking'|translate}}.", {
        uid: bridge.id,
        persistent: true,
        data: {name: _call.name || data.conferenceCallName},
        snoozable: true,
      });
    }
  };

  var pusherSubs = [
    {topic: PusherPubsub.types.CALLER_NAME_CHANGE, fn: onCallerNameChange},
    {topic: PusherPubsub.types.CALLER_JOINED, fn: onCallerJoin},
    {topic: PusherPubsub.types.CALLER_LEFT, fn: onCallerLeft},
    {topic: PusherPubsub.types.CALLER_MUTED, fn: onCallerMuted},
    {topic: PusherPubsub.types.CALLER_DEAFENED, fn: onCallerDeafened},
    {topic: PusherPubsub.types.CALLER_NUDGED, fn: onCallerNudget},
    {topic: PusherPubsub.types.NAME_RECORDED, fn: onNameRecorded},
    {topic: PusherPubsub.types.SPEAKER_CHANGE, fn: onSpeakerChange},
  ];

  pusherSubs.forEach(function(sub) {
    subscribe(PusherPubsub, sub.topic, sub.fn);
  });

  /**
   * Required data for this event:
   * bridgeId
   * locked
   */
   $scope.$on('pusher:conference:conference_locked', function(event, data) {
    var bridge = findBridge(data.bridgeId);
    bridge.locked = data.locked;

    Toast.notify("{{'The conference has been'|translate}} {{status|translate}}.", {data: {
      status: data.locked ? 'locked' : 'unlocked'
    }});
  });

  /**
   * Required data for this event:
   * bridgeId
   */
  $scope.$on('pusher:conference:conference_ended', onConferenceEnded);

  function onConferenceEnded(event, data) {
    var bridge = findBridge(data.bridgeId);
    updateBridgeActiveCalls(bridge);

    Toast.notify('<strong>{{\'The conference has ended\'|translate}}</strong>', {uid: bridge.id, persistent: false});
  }

  $scope.addSomeone = function(bridgeId, tel) {
    var bridge = findBridge(bridgeId);
    var formattedNumber = tel, plan = $scope.userInfo.plan;
    tel = tel.replace(/[^0-9]+/g, "");

    if (plan.unlimited) {
      return Toast.error('Roundup / Outbound dialing is a feature that is exclusively available on our minute based plans.  Upgrade today to enjoy outbound and inbound access to your conference calls.');
    }

    var len_tel = tel.length;
    if (len_tel > 11 && plan.trial_period_days > 0) {
      return Toast.error('Roundup is a feature that we have had to limit to our paying customers, based on recent abuse by trail users.');
    }

    Api.bridges.addPerson(bridge, tel)
      .then(Toast.notify.bind(0, formattedNumber + ' has been invited to the conference.'))
      .catch(function(err) {
        var errMsg = (err && err.data && err.data.msg) || '';
        if (errMsg.toLowerCase().indexOf('account status is not eligible') > -1) {
          modals.popupAlert(Object.assign($scope.$new(), {alert: {
            title: 'Something went wrong performing this action',
            content: errMsg,
          }})).modal();
        }
        Toast.error("{{'Something went wrong performing this action'|translate}}. {{'Please try again!'|translate}}");
      });
  };

  $scope.phoneNumberPattern = (function() {
    var regexp = /^[(]{0,1}[0-9]{3,10}[)\.\- ]{0,1}[0-9]{3,10}[\.\- ]{0,1}[0-9]{4,10}$/;
    return {
      test: function(value) {
        return regexp.test(value);
      }
    };
  })();

  $scope.formatByTimezone = function(date, format){
    return moment(date).tz(userInfo.home_time_zone).format(format);
  };

  $scope.showSmsBroadcastModal = function() {
    modals.broadcastSms($scope).modal();
  };

  $scope.broadcastSms = function(message) {
    Api.bridges.broadcastSms({bridge_id: $scope.d.ACTIVE_BRIDGE.id, message: message})
    .then(Toast.notify.bind(0, "{{'SMS successfully sent to all participants'|translate}}."));
  };

  $scope.shareLink = function(bridge) {
    return bridge.short_url + "app/#join-call/" + bridge.token_link_anon + "?bid="+bridge.id;
  };

  $scope.screenLink = function(bridge) {
    return bridge.short_url + "app/#view-screen/"+bridge.token_link_anon+"?bid="+bridge.id;
  };

  $scope.hangupAll = function(bridge) {
    Api.bridges.hangupBridge(bridge);
  };

  $scope.muteAll = function(bridge) {
    Api.bridges.muteBridge(bridge).then(
      Toast.notify.bind(0, "{{'Bridge successfully muted'|translate}}."));
  };

  $scope.toggleHoldMute = function(bridge) {
    var conference = $scope.d.CONFERENCE;
    if (!conference) {
      return;
    }

    Api.bridges.toggleHoldMute(conference.id).then(function() {
      $timeout(function() {
        conference.hold_mute = !conference.hold_mute;
        Toast.notify('Conference successfully '+(conference.hold_mute ? 'muted' : 'unmuted')+'.');
        $scope.d.CONFERENCE.hold_mute = conference.hold_mute;
      });
    }, function() {
      Toast.error('Sorry there was an error, please try again later!');
    });
  };

  function subscribe(serv, topic, fn) {
    var subj = serv.sub(topic, fn),
      unsub = subj && subj.unsub && typeof subj.unsub === 'function' ? subj.unsub : angular.noop;

    $scope.$on('$destroy', unsub);
  }

  $scope.fsProfile = function(bridge) {
    return (bridge.jfb_url.match(/http:\/\/(.*).bblapp.io/) || [])[1];
  };

  $scope.deleteTiedLine = function (line) {
    Api.bridges.deleteDid(line.id).then(function() {
      Api.bridges.fetch({limit: 100}, {cache: false});
    }, Toast.error.bind(Toast, "{{'There was an error deleting the line'|translate}}!"));
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/dashboard.controller.js
 ** module id = 321
 ** module chunks = 0
 **/